export function getAvatarUrl(path) {
  if (!path) return '';
  const encoded = encodeURIComponent(path);
  return `/backend/api/download.php?file=${encoded}&v=${Date.now()}`;
}
